export class GcpSubnet {
    'id';
    'vpcNetwork';
    'name';
    'project';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "vpcNetwork",
            "baseName": "vpcNetwork",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "project",
            "baseName": "project",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSubnet.attributeTypeMap;
    }
    constructor() {
    }
}
